import { Store } from "../redux/store";
import JobsService from "../services/JobsService";
import { setJobsQueue } from "../redux/actions";

const fetchGradeJobQueue = async () => {
  try {
    const jobs = await JobsService.getJobQueue();
    Store.dispatch(setJobsQueue(jobs));
  } catch (error) {
    console.error("Erro ao buscar fila de jobs:", error);
  }
};

export default fetchGradeJobQueue;
